import { capitalizeFirstLetter } from '@src/utils/capitalizeFirstLetter';

export const filterPostsByCategory = (postsToFilter, categoryToFind) =>
  postsToFilter.filter((post) => post.postCategories.map((category) => category.name).includes(categoryToFind));

export const filterPostsBySearchTerm = (postsToFilter, filterTerm) =>
  postsToFilter.filter((post) => {
    return (
      post.title.toLowerCase().trim().includes(filterTerm.toLowerCase().trim()) ||
      post.authors
        .map(({ name }) => name)
        .join(' ')
        .toLowerCase()
        .trim()
        .includes(filterTerm.toLowerCase().trim()) ||
      post.blogKeywords[0]
        .split(' ')
        .map((kw) => kw.toLowerCase().trim())
        .some((kw) => kw.includes(filterTerm.toLowerCase().trim())) ||
      post.searchKeywords.some((kw) => kw.toLowerCase().trim() === filterTerm.trim().toLowerCase())
    );
  });

export const getHeader = (pathname) => {
  const transformedPath = capitalizeFirstLetter(pathname.slice(6).split('-').join(' '));
  if (pathname === '/blog/') {
    return 'All articles';
  } else return transformedPath.endsWith('/') ? transformedPath.slice(0, -1) : transformedPath;
};

export const getBlogPosts = (currentBlogCategory, searchTerm, blogPostsData) => {
  if (currentBlogCategory === 'All' && searchTerm === '') {
    return blogPostsData;
  } else if (currentBlogCategory === 'All') {
    return filterPostsBySearchTerm(blogPostsData, searchTerm);
  } else {
    return filterPostsByCategory(blogPostsData, currentBlogCategory);
  }
};

export const getCurrentPostsData = (blogPosts, firstPageSize, activePage, pageSize) => {
  if (blogPosts.length <= firstPageSize) {
    return blogPosts;
  } else {
    const firstPageIndex = activePage === 1 ? 0 : firstPageSize + (activePage - 2) * pageSize;
    const lastPageIndex = activePage === 1 ? firstPageSize : firstPageIndex + pageSize;
    return blogPosts.slice(firstPageIndex, lastPageIndex);
  }
};
